export const useWorkspaceSettingsLink = () => {
  return (workspaceId: number | 'last') => `/workspaces/${workspaceId}/settings`;
};
